import { useQuery } from "@tanstack/react-query"
import { QRByIdQuery } from "../../../lib/templates/qr/QRByIdQuery"

export function useQRByIdQuery(...args: Parameters<typeof QRByIdQuery>) {
  return useQuery(QRByIdQuery(...args))
}
